export type Nationality =
	| 'US'
	| 'CHINA'
	| 'GERMANY'
	| 'JAPAN'
	| 'INDIA'
	| 'UK'
	| 'FRANCE'
	| 'ITALY'
	| 'BRAZIL'
	| 'CANADA'
	| 'RUSSIA'
	| 'SOUTH_KOREA'
	| 'SPAIN'
	| 'AUSTRALIA'
	| 'MEXICO'
	| 'INDONESIA'
	| 'NETHERLANDS'
	| 'SAUDI_ARABIA'
	| 'TURKEY'
	| 'TAIWAN'
	| 'ISRAEL'
	| 'SWEDEN'
	| 'SOUTH_AFRICA'
	| 'PORTUGAL'
	| 'COLOMBIA'
	| 'AUSTRIA'
	| 'IRELAND'
	| 'BELGIUM'
	| 'GREECE'
	| 'IRAN'
	| 'NORWAY'
	| 'NEW_ZEALAND'
	| 'POLAND'
	| 'CZECH'
	| 'HUNGARY'
	| 'SWITZERLAND'
	| 'CHILE'
	| 'ARGENTINA'
	| 'PERU'
	| 'DENMARK'
	| 'FINLAND'
	| 'EGYPT'
	| 'NIGERIA'
	| 'UKRAINE'
	| 'VIETNAM'
	| 'PHILIPPINES'
	| 'SINGAPORE'
	| 'ICELAND'

export function getNationalityKoreanName(nationality: Nationality): string {
	const names: Record<Nationality, string> = {
		US: '미국',
		CHINA: '중국',
		GERMANY: '독일',
		JAPAN: '일본',
		INDIA: '인도',
		UK: '영국',
		FRANCE: '프랑스',
		ITALY: '이탈리아',
		BRAZIL: '브라질',
		CANADA: '캐나다',
		RUSSIA: '러시아',
		SOUTH_KOREA: '한국',
		SPAIN: '스페인',
		AUSTRALIA: '호주',
		MEXICO: '멕시코',
		INDONESIA: '인도네시아',
		NETHERLANDS: '네덜란드',
		SAUDI_ARABIA: '사우디아라비아',
		TURKEY: '튀르키예',
		TAIWAN: '대만',
		ISRAEL: '이스라엘',
		SWEDEN: '스웨덴',
		SOUTH_AFRICA: '남아공',
		PORTUGAL: '포르투갈',
		COLOMBIA: '콜롬비아',
		AUSTRIA: '오스트리아',
		IRELAND: '아일랜드',
		BELGIUM: '벨기에',
		GREECE: '그리스',
		IRAN: '이란',
		NORWAY: '노르웨이',
		NEW_ZEALAND: '뉴질랜드',
		POLAND: '폴란드',
		CZECH: '체코',
		HUNGARY: '헝가리',
		SWITZERLAND: '스위스',
		CHILE: '칠레',
		ARGENTINA: '아르헨티나',
		PERU: '페루',
		DENMARK: '덴마크',
		FINLAND: '핀란드',
		EGYPT: '이집트',
		NIGERIA: '나이지리아',
		UKRAINE: '우크라이나',
		VIETNAM: '베트남',
		PHILIPPINES: '필리핀',
		SINGAPORE: '싱가포르',
		ICELAND: '아이슬란드',
	}
	return names[nationality]
}

export function getNationalityFlag(nationality: Nationality): string {
	const flags: Record<Nationality, string> = {
		US: '🇺🇸',
		CHINA: '🇨🇳',
		GERMANY: '🇩🇪',
		JAPAN: '🇯🇵',
		INDIA: '🇮🇳',
		UK: '🇬🇧',
		FRANCE: '🇫🇷',
		ITALY: '🇮🇹',
		BRAZIL: '🇧🇷',
		CANADA: '🇨🇦',
		RUSSIA: '🇷🇺',
		SOUTH_KOREA: '🇰🇷',
		SPAIN: '🇪🇸',
		AUSTRALIA: '🇦🇺',
		MEXICO: '🇲🇽',
		INDONESIA: '🇮🇩',
		NETHERLANDS: '🇳🇱',
		SAUDI_ARABIA: '🇸🇦',
		TURKEY: '🇹🇷',
		TAIWAN: '🇹🇼',
		ISRAEL: '🇮🇱',
		SWEDEN: '🇸🇪',
		SOUTH_AFRICA: '🇿🇦',
		PORTUGAL: '🇵🇹',
		COLOMBIA: '🇨🇴',
		AUSTRIA: '🇦🇹',
		IRELAND: '🇮🇪',
		BELGIUM: '🇧🇪',
		GREECE: '🇬🇷',
		IRAN: '🇮🇷',
		NORWAY: '🇳🇴',
		NEW_ZEALAND: '🇳🇿',
		POLAND: '🇵🇱',
		CZECH: '🇨🇿',
		HUNGARY: '🇭🇺',
		SWITZERLAND: '🇨🇭',
		CHILE: '🇨🇱',
		ARGENTINA: '🇦🇷',
		PERU: '🇵🇪',
		DENMARK: '🇩🇰',
		FINLAND: '🇫🇮',
		EGYPT: '🇪🇬',
		NIGERIA: '🇳🇬',
		UKRAINE: '🇺🇦',
		VIETNAM: '🇻🇳',
		PHILIPPINES: '🇵🇭',
		SINGAPORE: '🇸🇬',
		ICELAND: '🇮🇸',
	}
	return flags[nationality]
}